module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "limiter"
  }, [_c('div', {
    staticClass: "container-login100",
    staticStyle: {
      "background-image": "url('static/assets/background.jpg')"
    }
  }, [_c('div', {
    staticClass: "wrap-login100"
  }, [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": "static/assets/logo-light.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login100-form validate-form"
  }, [_c('div', {
    staticClass: "wrap-input100 validate-input"
  }, [_c('the-mask', {
    ref: "inStoreNumber",
    staticClass: "input100",
    attrs: {
      "type": "tel",
      "maxlength": "4",
      "mask": "####",
      "placeholder": _vm.$t('enter_store_number')
    },
    model: {
      value: (_vm.storeNumber),
      callback: function($$v) {
        _vm.storeNumber = $$v
      },
      expression: "storeNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container-login100-form-btn"
  }, [_c('button', {
    staticClass: "login100-form-btn",
    on: {
      "click": function($event) {
        return _vm.loginWithStoreNumber('K')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-in-alt "
  }), _vm._v("\r\n                  KDS\r\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "login100-form-btn",
    on: {
      "click": function($event) {
        return _vm.loginWithStoreNumber('B')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-in-alt "
  }), _vm._v("\r\n                  BIN\r\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "login100-form-btn",
    on: {
      "click": function($event) {
        return _vm.loginWithStoreNumber('G')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-in-alt "
  }), _vm._v("\r\n                  GFB\r\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "left": "0px",
      "bottom": "0px",
      "width": "100%",
      "z-index": "20"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "color": "#ffffff",
      "padding-left": "20px"
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('build_version')) + ": " + _vm._s(_vm.build) + "\r\n              ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40px",
      "padding-right": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-block btn-lg btn-danger",
    staticStyle: {
      "height": "42px",
      "padding": "9px",
      "font-weight": "bold",
      "border-radius": "50%",
      "border": "solid 1px #ffffff"
    },
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-redo pull-left",
    staticStyle: {
      "margin": "2px -20px 0px 0px"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c720a4e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 536
// module chunks = 2